import config from 'config/config'
import {
  classNames,
  sortableListDragSourceDragMarker,
  sortableListDropTargetDragMarker,
} from 'lib/utilities'
import React from 'react'
import { DragSource, DropTarget } from 'react-dnd'
import { Icon, Table } from 'semantic-ui-react'

class ProductCriteriaPropertyRow extends React.Component {
  render() {
    const { index, property, deleteCriteria, dragMarker = {} } = this.props //ownProps
    const { isDragging, connectDragSource, connectDropTarget } = this.props //DragSource, DropTarget
    if (!property) return false
    let rowClass = isDragging && 'isDragging'
    let dragIndicator
    if (dragMarker.index === index) {
      dragIndicator = dragMarker.position
    }
    return connectDragSource(
      connectDropTarget(
        <tr className={classNames([rowClass, dragIndicator])}>
          <Table.Cell
            collapsing
            className="draggable"
            content={<Icon {...config.icons.draggable} link />}
          />
          <Table.Cell>{property.id}</Table.Cell>
          <Table.Cell>
            <span className="german tag">{property.name_de}</span>
            <span className="french tag">{property.name_fr}</span>
          </Table.Cell>
          <Table.Cell>
            <Icon {...config.icons.unlink} onClick={deleteCriteria} />
          </Table.Cell>
        </tr>
      )
    )
  }
}

ProductCriteriaPropertyRow = DropTarget(
  'ProductCriteria',
  sortableListDropTargetDragMarker,
  (connect) => ({ connectDropTarget: connect.dropTarget() })
)(ProductCriteriaPropertyRow)
ProductCriteriaPropertyRow = DragSource(
  'ProductCriteria',
  sortableListDragSourceDragMarker,
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  })
)(ProductCriteriaPropertyRow)
export default ProductCriteriaPropertyRow



// WEBPACK FOOTER //
// ./src/components/admin/Products/Segments/ProductCriteriaPropertyRow.jsx